module.exports = __webpack_public_path__ + "static/img/net-error.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/net-error.png
// module id = 579
// module chunks = 0